const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

/** Read at the moment of use: a hook that animates checks it when it starts. */
const prefersReducedMotion = () =>
  Boolean(window.matchMedia?.(REDUCED_MOTION_QUERY)?.matches);

export default prefersReducedMotion;
